const FONT_FAMILY = "Graphik Trial, sans-serif";


const dataLabelConfig = {
    style: {
        fontFamily: FONT_FAMILY,
        fontSize: 12,
    },
    position: 'inside',
    transform: [
        {
          type: 'overflowHide',
        },

    ],
}

const axisConfig = {
  labelFill: "#000",
  labelOpacity: 0.9,
  labelFontFamily: FONT_FAMILY,
    labelAutoRotate: false,
    lineStroke: 'red',
    grid: {
      and: {
          gridStroke: 'red',
          gridStrokeOpacity: '1'
      },
        gridStroke: 'red',
          gridStrokeOpacity: '1',
        line: {
          style: {
            stroke: 'red',
          },
        },
    }
}

const tooltipConfig = {
    titleFontFamily: FONT_FAMILY,
    titleStroke: "#000",
    titleStrokeOpacity: 0.8,
}



export const useAntCharts = () => {
    return {
        axisConfig,
        dataLabelConfig,
        tooltipConfig
    }
};